import { useRequest } from 'features/request/useRequest';
import { WorkOrderStatusEnum } from 'gql/graphql';
import type { UerRemoveActKc2PriceFromWorkOrderMutation, UerRemovePriceFromWorkOrderMutation } from 'gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { qglRemoveActKC2PriceFromWorkOrder, qglRemovePriceFromWorkOrder } from '../workOrderQueries';

export const useDeleteWorkOrderPrice = (checkedWorkOrderPriceIds: number[], workOrderStatus?: WorkOrderStatusEnum) => {
    const dispatch = useDispatch();

    const isInProgress = workOrderStatus === WorkOrderStatusEnum.InProgress;

    const query: any = useMemo(
        () => (isInProgress ? qglRemoveActKC2PriceFromWorkOrder : qglRemovePriceFromWorkOrder),
        [isInProgress],
    );
    const [
        deletePriceWorkOrderData,
        deletePriceWorkOrderStatus,
        deletePriceWorkOrderError,
        deletePriceWorkOrderRequest,
        deletePriceWorkOrderSetData,
    ] = useRequest<UerRemoveActKc2PriceFromWorkOrderMutation & UerRemovePriceFromWorkOrderMutation>({
        requestId: `removeWorkOrderPriceRows`,
        query,
        withEffect: false,
    });

    const handleDeletePriceWorkOrder = useCallback(() => {
        dispatch(deletePriceWorkOrderRequest({ workOrderPriceIds: checkedWorkOrderPriceIds }));
    }, [deletePriceWorkOrderRequest, dispatch, checkedWorkOrderPriceIds]);

    return {
        deletePriceWorkOrderData: isInProgress
            ? deletePriceWorkOrderData?.uerRemoveActKC2PriceFromWorkOrder
            : deletePriceWorkOrderData?.uerRemovePriceFromWorkOrder,
        deletePriceWorkOrderStatus,
        deletePriceWorkOrderError,
        deletePriceWorkOrderSetData,
        handleDeletePriceWorkOrder,
    };
};
